//@ts-ignore
import Swiper, { Autoplay } from "swiper";

const init = () => {
  Swiper.use([Autoplay]);

  const slider = new Swiper("[data-kasteel-auto-image-slider]", {
    slidesPerView: "auto",
    spaceBetween: 64,
    loop: true,
    autoplay: true,
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
